export default {
    en: {
        'modalTitle' : 'User Info.',
        'korNm': 'Name',
        'engNm': 'Name(English)',
        'rrn': 'ID No.',
        'officeTelNo': 'Extention No.',
        'hpTelNo': 'Phone(Mobile)',
        'homeTelNo': 'Phone(Home)',
        'nation': 'Nationality',
        'emailAddress' : 'E-mail',
        'zipCode': 'Zip Code',
        'address': 'Address',
        'hireDate': 'Date of Appointment',
        'promotionDate': 'Date of Promotion',
        'rmLevel': 'Time-in-Service-Grade',
        'rmDate': 'Date of TIS Grade-up',
        'perLevel': 'Salary Pay-Step',
        'prDate': 'Date of Salary Raise'
    },
    ko: {
        'modalTitle' : '신상정보조회',
        'korNm': '성명',
        'engNm': '영문성명',
        'rrn': '주민번호',
        'officeTelNo': '내선',
        'hpTelNo': '휴대전화',
        'homeTelNo': '집전화',
        'nation': '국적',
        'emailAddress' : '이메일',
        'zipCode': '우편번호',
        'address': '현주소',
        'hireDate': '임용일',
        'promotionDate': '현직위승진일',
        'rmLevel': '현 연구호봉',
        'rmDate': '승봉일',
        'perLevel': '현 급여호봉',
        'prDate': '승봉일'
    },
}